module.exports = __webpack_public_path__ + "site/img/168.660e0336.jpg";